/* eslint-disable */
import axios from 'axios'
import * as vars from '@/vars.json'

const httpAxios = axios.create({
    params: {},
})

export const promotions = {
    namespaced: true,
    state: {
        shopPromotionsList: [],
        coupon: null,
        referral: '',
        promotions: [],
        addedCoupon: false
    },

    mutations: {
        SET_COUPON: (state, data) => {
            state.coupon = data;
        },
        SET_REFERRAL: (state, data) => {
            state.referral = data;
        },
        SET_PROMOTIONS: (state, data) => {
            state.promotions = data;
        },
        SET_ADDED_COUPON: (state, data) => {
            state.addedCoupon = data;
        }
    },

    actions: {
        saveFirstCodePromotion({ rootState }, valuePromotion) {
            const shopId = rootState.shops.currentItem.id;
            const userId = rootState.users.user.uid;
            return new Promise((resolve, reject) => {
                httpAxios.post(vars.url + '/addFirstBuyPromotion', { uid: userId, value: valuePromotion, shopId: shopId }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                });
            });
        },
        addFirstBuyCoupon({ commit, rootState }, payload) {
            if (payload.uid === '') {
                payload.uid = rootState.users.user.uid;
            }
            // console.log(payload);
            return new Promise((resolve, reject) => {
                httpAxios.post(vars.url + '/addFirstBuyCoupon', { uid: payload.uid, ownerId: payload.shopOwner, shopId: payload.shopId, isReferral: payload.isReferral }).then((response) => {
                    if (!payload.isReferral) {
                        commit('SET_ADDED_COUPON', response.data);
                    }
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                });
            });
        },
        couponValidator({ commit, rootState }, couponCode) {
            const userId = rootState.users.user.uid;
            return new Promise((resolve, reject) => {
                httpAxios.post(vars.url + '/validateCoupon', { code: couponCode, uid: userId }).then((response) => {
                    commit('SET_COUPON', response.data);
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        changeStateCoupon({ commit, rootState }, couponId) {
            const userId = rootState.users.user.uid;
            return new Promise((resolve, reject) => {
                httpAxios.post(vars.url + '/changeStateCoupon', { coupon: couponId, uid: userId }).then((response) => {
                    commit('SET_COUPON', null);
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        referralValidator({ commit }, payload) {
            return new Promise((resolve, reject) => {
                httpAxios.post(vars.url + '/verifyReferral', { referral: payload.referralCode, userCode: payload.userCode }).then((response) => {
                    commit('SET_REFERRAL', response.data);
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        getPromotions({ commit, rootState }) {
            const shopId = rootState.shops.currentItem.id;
            const userId = rootState.users.user.uid;
            return new Promise((resolve, reject) => {
                httpAxios.post(vars.url + '/getPromotions', { uid: userId, shopId }).then((response) => {
                    // console.log(response.data)
                    commit('SET_PROMOTIONS', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        deleteCoupon({ commit }) {
            commit('SET_COUPON', null);
        },
        saveCoupon({ commit }, coupon) {
            //const userId = rootState.users.user.uid;
            commit('SET_COUPON', coupon);
        },
    },
    getters: {
        getCoupon(state) {
            return state.coupon
        },
        getReferral(state) {
            return state.referral
        },
        getPromotions(state) {
            return state.promotions
        },
        getAddedCoupon(state) {
            return state.addedCoupon
        }
    }
}